<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}角色`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
        <div class="panel form">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="角色名称">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="开通权限">
                    <el-tree ref="tree"
                        class="fx-g1 func_tree"
                        :data="navs"
                        show-checkbox
                        node-key="id"
                        :default-expand-all="true"
                        :default-checked-keys="form.funcIds"
                        :expand-on-click-node="false"
                        :props="defaultProps">
                    </el-tree>
                </el-form-item>
            </el-form>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: {...this.item, "funcIds": (this.item.funcIds ? this.item.funcIds.split(",") : [])},
                navs: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    disabled: true
                },
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                let checkIds = this.$refs.tree.getCheckedNodes().filter(node => {
                    return node.clickType == 5 || node.funcType == 6; //只要打开url的权限 和 非菜单权限
                }).map(n => n.id);

                let data = {...this.form, "funcIds": checkIds.join(",")};
                this.$ajaxPost("/role/save", {
                    role: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                // this.$refs.tree.getCheckedKeys()
                return false;
            },
            loadFuncs() {
                this.$ajaxGet("/function/institutionFunctionTree" , (data) => {
                    this.navs = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadFuncs();
        }


    }
</script>
